import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PDFDocument } from 'pdf-lib';

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  
  constructor(private http: HttpClient) {}

  /**
   * Fetch PDF from URL and return as ArrayBuffer
   */
  async extractPages(pdfUrl: string): Promise<ArrayBuffer> {
    const response = await fetch(pdfUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF: ${response.statusText}`);
    }
    return await response.arrayBuffer();
  }

  /**
   * Reorder PDF pages based on new order array
   * @param pdfBytes Original PDF as ArrayBuffer
   * @param newOrder Array of page indices in desired order (0-indexed)
   * @returns Reordered PDF as Uint8Array
   */
  async reorderPages(pdfBytes: ArrayBuffer, newOrder: number[]): Promise<Uint8Array> {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const newPdf = await PDFDocument.create();
    
    // Copy pages in new order
    for (const pageIndex of newOrder) {
      const [copiedPage] = await newPdf.copyPages(pdfDoc, [pageIndex]);
      newPdf.addPage(copiedPage);
    }
    
    return await newPdf.save();
  }

  /**
   * Get total number of pages in PDF
   */
  async getPageCount(pdfBytes: ArrayBuffer): Promise<number> {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    return pdfDoc.getPageCount();
  }

  /**
   * Convert Uint8Array to Blob for downloading
   */
  createPdfBlob(pdfBytes: Uint8Array): Blob {
    return new Blob([pdfBytes as any], { type: 'application/pdf' });
  }

  /**
   * Download PDF to user's computer
   */
  downloadPdf(pdfBytes: Uint8Array, fileName: string): void {
    const blob = this.createPdfBlob(pdfBytes);
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }
}

